import React from 'react';
import { motion } from 'framer-motion';
const items = [{
  title: 'SISTEMAS',
  desc: 'Diseñamos cómo las herramientas trabajan juntas.'
}, {
  title: 'IA CON PROPÓSITO',
  desc: 'Automatizamos procesos concretos. No agregamos IA por moda.'
}, {
  title: 'EVOLUCIÓN',
  desc: 'Construimos sistemas que pueden crecer contigo.'
}];
export function WhyOrigen() {
  return <section className="bg-arena py-[56px] md:py-[80px]" data-id="element-291" data-mp="1jsjarai1z72t">
      <div className="max-w-[1000px] mx-auto px-6 md:px-20" data-id="element-292" data-mp="1ju45p18a4s17">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-293" data-mp="1f0rj0wn5uvb3">
          {items.map((item, idx) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.35,
          ease: 'easeOut',
          delay: idx * 0.06
        }} className="text-center md:text-left" data-id="element-294" data-mp="1b0hcnivgi2vp" data-mpi={idx}>
              <span className="block font-body text-[12px] uppercase tracking-[0.1em] text-salvia mb-2" data-id="element-295" data-mp="3p05ygzukwwi5">
                {item.title}
              </span>
              <p className="font-body text-[15px] text-carbon/65 leading-[1.6]" data-id="element-296" data-mp="3ts5uwibfx79z">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}